<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { checkVersion } from "@utils/version";
export default {
  name: "App",
  created() {
    checkVersion();
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-size: 12px;
}
</style>
